"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    fontFamily: "Akkurat, sans-serif",
    fontWeight: "normal",
    fontSize: "18px",
    lineHeight: "24px"
  },
  icon: {},
  label: {}
}));

const PathButton = ({
  style,
  icon,
  title,
  label,
  value,
  disabled,
  expanded,
  controls,
  onToggle,
  forwardedRef
}) => {
  const classes = useStyles();
  return _react.default.createElement(_ButtonBase.default, {
    className: classes.root,
    style: style,
    ref: forwardedRef,
    disabled: disabled,
    "aria-controls": expanded ? controls : undefined,
    "aria-expanded": expanded ? 'true' : undefined,
    "aria-label": "options",
    "aria-haspopup": "menu",
    onClick: onToggle
  }, label || title || value);
};

var _default = PathButton;
exports.default = _default;
module.exports = exports.default;